var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEu = function SvgEu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "EU_svg__a",
    width: 182,
    height: 182,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#EU_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009",
    d: "M190.909 9.09H9.091v181.82h181.818V9.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    fillRule: "evenodd",
    d: "m165.584 107.403-5.933-4.377-6.19 4.348 2.401-6.899-6.113-4.448 7.411.114 2.41-7.092 2.186 6.965 7.604.064-6.065 4.195zm-8.039-29.493-5.933-4.376-6.191 4.347 2.402-6.898-6.113-4.448 7.41.114 2.41-7.092 2.186 6.965 7.605.063-6.066 4.195 2.29 7.13m-21.336-21.283-5.933-4.376-6.191 4.347 2.402-6.898-6.113-4.448 7.411.114 2.41-7.093 2.186 6.966 7.604.064-6.066 4.194 2.29 7.13m-29.994-8.209-5.933-4.376-6.19 4.347 2.402-6.898-6.114-4.448 7.41.114 2.411-7.092 2.186 6.965 7.604.063-6.066 4.195 2.29 7.13M76.53 56.323l-5.932-4.376-6.19 4.347 2.4-6.898-6.112-4.448 7.41.114 2.41-7.093 2.187 6.966 7.604.063-6.066 4.195 2.29 7.13M54.267 77.606l-5.932-4.376-6.19 4.347 2.4-6.898-6.113-4.448 7.41.114 2.41-7.092 2.188 6.965 7.603.063-6.065 4.195 2.29 7.13m-8.04 29.492-5.933-4.375-6.19 4.346 2.401-6.898-6.113-4.448 7.41.114 2.41-7.092L42.4 95.71l7.604.064-6.066 4.194 2.29 7.13m8.039 30.101-5.932-4.376-6.19 4.347 2.4-6.898-6.113-4.448 7.41.113 2.41-7.092 2.188 6.966 7.603.064-6.065 4.194 2.29 7.13m21.644 21.891-5.932-4.376-6.19 4.347 2.4-6.898-6.112-4.448 7.41.114 2.41-7.093 2.187 6.966 7.604.063-6.066 4.195 2.29 7.13m29.993 7.905-5.932-4.376-6.191 4.346 2.402-6.898-6.114-4.447 7.41.114 2.41-7.092 2.187 6.965 7.604.063-6.066 4.195zm29.994-7.905-5.933-4.376-6.191 4.347 2.402-6.898-6.113-4.448 7.41.114 2.41-7.093 2.187 6.966 7.604.063-6.066 4.195zm22.263-21.891-5.933-4.376-6.19 4.347 2.402-6.898-6.114-4.448 7.411.113 2.41-7.092 2.186 6.966 7.604.064-6.065 4.194z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0,
    strokeWidth: 3,
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909Z"
  })));
};
export default SvgEu;